import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { interval, Subscription } from 'rxjs';

import { CookieService } from './cookie.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalLogoutService {

  private subscription!: Subscription;

  private currentStamp = '';

  constructor(
    private cookieService: CookieService,
    private oauthService: OAuthService,
  ) { }

  startWatching(): void {

    this.currentStamp = this.cookieService.getCookie('andica_logout_stamp');
    this.subscription = interval(2000).subscribe(() => {
      const latest = this.cookieService.getCookie('andica_logout_stamp');
      console.log('Current:', this.currentStamp);
      console.log('Latest:', latest);

      if (this.currentStamp && latest && this.currentStamp !== latest) {
        console.log('LOGOUT DETECTED');
        this.logoutUser();
      }

      this.currentStamp = latest;

    });
  }

  publishLogout(): void {
    this.cookieService.setCookie('andica_logout_stamp', Date.now().toString());
  }

  logoutUser(): void {
    this.subscription?.unsubscribe();
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.setItem('ProductLogedout', 'Yes')
    this.oauthService.logOut()
    this.oauthService.revokeTokenAndLogout();
  }
}
